
import { DateToFormat, DatetimeToDate } from "./datetime.js";

function renderFormPages(pages) {
    return pages.map((page) => {
        return renderFormPage(page);
    });
}

function renderFormPage(page, template, fields) {
    return (
        <div key={page.id} className="card mb-2">
            <div className="card-header sm">
                <div className="typo-strong-175">{page.title}</div>
            </div>
            <div className="card-content sm">
                {page.lines.map((line, index) => renderFormLine(page.id, line, index, page.lines.length === index + 1, template, fields))}
            </div>
        </div>
    );
}

function renderFormLine(pageID, line, lineIndex, isLastLine, template, fields, dateFormat, isFieldMissing) {
    // Line example
    //[{"code": "firstName", "size": 6}, {"code": "lastName", "size": 6}]

    return (
        <div key={"page_"+pageID+"_line_"+lineIndex} className={"row " + (isLastLine ? "" : "mb-2")}>
            {line.map((lineField, index) => {
                let field = template.find((f) => f.code === lineField.code);
                let fieldPatient = fields.find((f) => f.code === field.code);

                let answer = fieldPatient && fieldPatient.answers.length>0 ? fieldPatient.answers[0] : "n/a";

                if (field.type === "date" && answer !== "n/a") {
                    answer = DateToFormat(DatetimeToDate(answer), dateFormat);
                }

                let missing = isFieldMissing ? isFieldMissing(field.code) : false;

                return (
                    <div key={"page_"+pageID+"_line_"+lineIndex+"_field_"+field.code} className={`col-xs-${lineField.size} py-0`}>
                        <div
                            className={"typo-strong-150" + (missing ? " text-red" : "")}
                            style={missing ? { background: '#FCD9D9', borderRadius: 8, padding: '2px 6px', display: 'inline-block' } : undefined}
                        >
                            {field.title}:
                        </div>
                        <div className={"typo-normal-150" + (missing ? " text-red" : "")}>{answer}</div>
                    </div>
                );
            })}
        </div>
    );
}

export { renderFormPages, renderFormPage, renderFormLine };